<template>
  <div>
    <div class="hr"></div>
    <div v-for="index in resolution" :key="index">
      <div class="resolution">
        <div class="text">
          <h4>Resolution {{ index }}</h4>
          Sample Resolution {{ index }}
        </div>
        <div v-for="stat in status" :key="stat">
          <div v-if="votingStatus == stat">
            <span v-html="field.metadata[stat]"></span>
          </div>
        </div>
      </div>
      <div class="hr"></div>
    </div>
  </div>
</template>

<script>
const STATUS = ["notStartedTempl", "endedTempl", "noRightsTempl"]

export default {
  name: "FormVFRT",
  props: {
    field: {
      type: Object,
    },
  },
  data() {
    return {
      resolution: [1, 2],
      status: STATUS,
      votingStatus: STATUS[2],
    };
  },
};
</script>

<style scoped>
.resolution {
  padding: 24px;
}

.text {
  padding-bottom: 1.5rem;
}

.text h4 {
  margin: 0;
}

.hr {
  background: #d7d7d7;
  height: 1px;
}

.required {
  color: #f00;
}
</style>